import type { TranslateFunction } from "lib/i18n/use-translation";

import { FeedbackStep } from "./types";

const getFeedbackSteps = (t: TranslateFunction): FeedbackStep[] => {
  return [
    {
      id: "stressLevel",
      titleHtml: t("feedback:steps.stressLevel.title"),

      __typename: "StartStep",
      input: {
        id: "1",
        label: "",
        required: false,
        options: [
          {
            id: "stressLevel-1",
            label: t("feedback:steps.stressLevel.options.more"),
            value: "3",
            imageUrl: "😣",
          },
          {
            id: "stressLevel-2",
            value: "2",
            label: t("feedback:steps.stressLevel.options.same"),
            imageUrl: "😐",
          },
          {
            id: "stressLevel-3",
            value: "1",
            label: t("feedback:steps.stressLevel.options.less"),
            imageUrl: "😌",
          },
        ],
      },
      response: {
        id: "",
        value: "",
      },
    },
    {
      id: "practice",
      titleHtml: t("feedback:steps.practice.title"),
      __typename: "RangeStep",
      input: {
        id: "2",
        label: "",
        required: true,
        options: [
          {
            id: "practice-3",
            label: t("feedback:steps.practice.options.no"),
            value: "3",
          },

          {
            id: "practice-2",
            label: t("feedback:steps.practice.options.unsure"),
            value: "2",
          },

          {
            id: "practice-1",
            label: t("feedback:steps.practice.options.yes"),
            value: "1",
          },
        ],
      },
      response: {
        id: "",
        value: "",
      },
    },
    {
      id: "likelyToRecommend",
      titleHtml: t("feedback:steps.recommend.title"),
      __typename: "RangeStep",
      input: {
        id: "3",
        label: "",
        required: true,
        options: [
          {
            id: "recommend-0",
            label: "0",
            value: "0",
          },
          {
            id: "recommend-1",
            label: "1",
            value: "1",
          },
          {
            id: "recommend-2",
            label: "2",
            value: "2",
          },
          {
            id: "recommend-3",
            label: "3",
            value: "3",
          },
          {
            id: "recommend-4",
            label: "4",
            value: "4",
          },
          {
            id: "recommend-5",
            label: "5",
            value: "5",
          },
          {
            id: "recommend-6",
            label: "6",
            value: "6",
          },
          {
            id: "recommend-7",
            label: "7",
            value: "7",
          },
          {
            id: "recommend-8",
            label: "8",
            value: "8",
          },
          {
            id: "recommend-9",
            label: "9",
            value: "9",
          },
          {
            id: "recommend-10",
            label: "10",
            value: "10",
          },
        ],
      },
      response: {
        id: "",
        value: "",
      },
    },
    {
      id: "feedback",
      titleHtml: t("feedback:steps.feedback.title"),
      __typename: "EndStep",
      input: {
        id: "4",
        type: "TextInput",
        label: "",
        required: false,
        maxLength: 0,
        minLength: 0,
        placeholder: t("feedback:steps.feedback.placeholder"),
      },
      response: {
        id: "",
        value: "",
      },
    },
  ];
};

export default getFeedbackSteps;
